import React from 'react';
import Input from "../Input-new/Input";
import PropTypes from "prop-types";
import Control from "../Control";
import Dropdown from "../Dropdown/Dropdown";

const LenderForm = ({theme = 'white', width, data, paneIndex, isFilter = false, handleSubmit, handleCancel, handleParentChange, handlePaneChange, handleParentDropdownChange}) => {

    const panes = [
      <React.Fragment>
        <div className={`form-title ${theme}`}>
          {isFilter ? "Lender" : "Add Lender"}
        </div>
        <Input
          theme={theme}
          width={width}
          valueType="text"
          name="name"
          label="Lender Name"
          value={data.name}
          required={!isFilter}
          handleParentChange={handleParentChange}
        />
        <Input
          theme={theme}
          width={width}
          valueType="text"
          name="first_name"
          label="Contact First Name"
          value={data.first_name}
          required={!isFilter}
          handleParentChange={handleParentChange}
        />
        <Input
          theme={theme}
          width={width}
          valueType="text"
          name="last_name"
          label="Contact Last Name"
          value={data.last_name}
          required={!isFilter}
          handleParentChange={handleParentChange}
        />
        <Input
          theme={theme}
          width={width}
          valueType="text"
          name="city"
          label="City"
          value={data.city}
          handleParentChange={handleParentChange}
        />
        <Dropdown
          theme={theme}
          data={data}
          optionsType="states"
          optionKey="abbr"
          optionLabelKey="name"
          value={data.state}
          valueKey="state"
          label="State"
          handleParentChange={handleParentDropdownChange}
        />
        {/* <Input
          theme={theme}
          width={width}
          valueType="text"
          name="contact_name"
          label="Contact Name"
          value={data.first_Name}
          handleParentChange={handleParentChange}
        /> */}
        <Input
          theme={theme}
          width={width}
          valueType="phone"
          name="contact_phone"
          label="Phone #"
          value={data.contact_phone}
          handleParentChange={handleParentChange}
        />
        <Input
          theme={theme}
          width={width}
          valueType="email"
          name="contact_email"
          label="Email"
          value={data.contact_email}
          handleParentChange={handleParentChange}
        />
      </React.Fragment>,
    ];

    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

LenderForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    width: PropTypes.number,
    data: PropTypes.object.isRequired,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
};

export default LenderForm;